export const templateImportDiagnosticDataDescription = "Mzw2ae";
export default {templateImportDiagnosticDataDescription};